export default __webpack_public_path__ + "static/media/trash-icon-black.b987c2e5.svg";